export class ErrorMessageResource {
    public static DUPLICATED_USERNAME = 'user:duplicated_username_exception';
    public static DUPLICATED_EMAIL = 'user:duplicated_email_exception';
}